/* GALLERY MAIN FUNCTION */
customElements.define('pro-gallery', class ProGallery extends HTMLElement {
    constructor() {
        super();
        this.length = this.dataset.mediaLength;
        console.log(this.dataset.pro_gallery_sticky_media_trigger_id, this.dataset.pro_gallery_share_popup_id)
        this.toggleSticky = this.querySelector(`#${this.dataset.pro_gallery_sticky_media_trigger_id}`);
        this.toggleShareSticky = this.querySelector(`#${this.dataset.pro_gallery_share_popup_id}`);

        this.toggleSticky && this.toggleSticky.addEventListener('change', () => {
            const body = document.querySelector('html');
            if(this.toggleSticky.checked || this.toggleShareSticky.checked){
                body.classList.add('pro_gallery_sticky_active');
            }else{
                body.classList.remove('pro_gallery_sticky_active');
            }
        })

        this.toggleShareSticky && this.toggleShareSticky.addEventListener('change', () => {
            const body = document.querySelector('html');
            if(this.toggleSticky.checked || this.toggleShareSticky.checked){
                body.classList.add('pro_gallery_sticky_active');
            }else{
                body.classList.remove('pro_gallery_sticky_active');
            }
        })

        this.galleryScrollToArray = this.querySelectorAll('[data-gallery-scroll-to]');
        //console.log(this.galleryScrollToArray)
        this.galleryScrollToArray.length && this.galleryScrollToArray.forEach(galleryScrollTo => {
            galleryScrollTo.addEventListener('click', () => {
                const parentScrollElement = this.querySelector('pro-gallery .pro-gallery-sticky-media .pro-gallery-sticky-media-content');
                const galleryOverviewItem = this.querySelector(`[data-gallery-title="${galleryScrollTo.dataset.galleryScrollTo}"]`);
                const galleryHeader = this.querySelector('.pro-gallery-sticky-media-header');
                if(parentScrollElement &&galleryOverviewItem && galleryHeader){
                    console.log(parentScrollElement, galleryOverviewItem.offsetTop, galleryHeader.offsetHeight)
                    const top_value = galleryOverviewItem.offsetTop - galleryHeader.offsetHeight;
                    parentScrollElement.scroll({
                        top: top_value,
                        behavior: 'smooth'
                    });
                }
            })
        })


        this.initMobSlider();
        this.initBlackStickySlider();
        this.initShareOptions();

        window.proGallery = this;
    }
    initShareOptions(){
        if(navigator.share){
            this.shareTriggers = this.querySelectorAll(`[for="${this.dataset.pro_gallery_share_popup_id}"]`);
            this.shareTriggers.length && this.shareTriggers.forEach(shareTrigger => {
                shareTrigger.htmlFor = '';
                shareTrigger.addEventListener('click', () => {
                    navigator.share({
                        title: this.dataset.share_title,
                        text: this.dataset.share_text,
                        url: window.location.href
                    })
                })
            })
        }else{
            this.initSharePopupIcons();
        }
    }
    initSharePopupIcons() {
        //pgs-copy-link pgs-copy-email pgs-copy-messages pgs-copy-whatsapp pgs-copy-messenger pgs-copy-facebook pgs-copy-twitter pgs-copy-embed
        //copy-link
        this.copyButtonTrigger = this.querySelector('.pgs-copy-link');
        this.copyButtonTrigger && this.copyButtonTrigger.addEventListener('click', () => {
            // Copy the text inside the text field
            const url = window.location.href;
            navigator.clipboard.writeText(url);

            //add param for tracking copy link
            const pgs_popup_message = this.querySelector('.pro-gallery-share-popup-messages .pro-gallery-share-popup-message-link-copied');
            pgs_popup_message.style.bottom = 'calc(-50vh + 36px)';
            setTimeout(() => {
                pgs_popup_message.style.bottom = '';
            }, 3000)
        })

        //email
        this.mailButtonTrigger = this.querySelector('.pgs-copy-email');
        this.mailButtonTrigger && this.mailButtonTrigger.addEventListener('click', () => {
            window.open(`mailto:?subject=${this.dataset.share_title}&amp;body=$${this.dataset.share_text} ${window.location.href}`, '_blank');
        })
        //messages
        this.messagesButtonTrigger = this.querySelector('.pgs-copy-messages');
        this.messagesButtonTrigger && this.messagesButtonTrigger.addEventListener('click', () => {
            window.open(`messages://send?body=${window.location.href}`, '_blank');
        })
        //twitter
        this.twitterButtonTrigger = this.querySelector('.pgs-copy-twitter');
        this.twitterButtonTrigger && this.twitterButtonTrigger.addEventListener('click', () => {
            window.open(`//twitter.com/share?url=${window.location.href}`, '_blank');
        })
        //facebook
        this.facebookButtonTrigger = this.querySelector('.pgs-copy-facebook');
        this.facebookButtonTrigger && this.facebookButtonTrigger.addEventListener('click', () => {
            window.open(`//www.facebook.com/sharer.php?u=${window.location.href}`, '_blank');
        })


        //whatsapp
        this.waButtonTrigger = this.querySelector('.pgs-copy-whatsapp');
        console.log(this.waButtonTrigger);
        this.waButtonTrigger && this.waButtonTrigger.addEventListener('click', () => {
            this.currentOptions = document.createElement('div');
            this.currentOptions.classList.add('pgs-copy-options-wrap');
            this.currentOptions.innerHTML = `
                    <div class="pgs-copy-options-backdrop">&nbsp;</div>
                    <div class="pgs-copy-options">
                        <div class="pgs-copy-open-action pgs-copy-open-app">
                            Open in App
                        </div>
                        <div class="pgs-copy-open-action pgs-copy-open-in-browser">
                            Open in Browser
                        </div>
                    </div>`;
            const app = this.currentOptions.querySelector('.pgs-copy-open-app');
            const browser = this.currentOptions.querySelector('.pgs-copy-open-in-browser');
            const backdrop = this.currentOptions.querySelector('.pgs-copy-options-backdrop');
            app && app.addEventListener('click', () => {
                this.currentOptions.remove();
                window.open(`whatsapp://send?text=${window.location.href}`, '_blank');
            })
            browser && browser.addEventListener('click', () => {
                console.log(this.currentOptions);
                this.currentOptions.remove();
                window.open(`https://web.whatsapp.com/send?text=${window.location.href}`, '_blank');
            })
            backdrop && backdrop.addEventListener('click', () => {
                this.currentOptions.remove();
            })
            this.waButtonTrigger.parentNode.parentNode.append(this.currentOptions);
        })
    }
    initBlackStickySlider(){
        this.stickySliderCurrentSlide = 0;
        this.stickySliderFooterText = this.querySelector('.pro-gallery-sticky-slider-footer p');
        this.toggleSliderStickySlides = this.querySelectorAll(`[for="${this.dataset.pro_gallery_sticky_slider_trigger_id}"]`);
        this.sliderStickyImageViewport = this.querySelector('.pro-gallery-sticky-slider-viewport img');
        this.sliderStickyVideoViewport = this.querySelector('.pro-gallery-sticky-slider-viewport video');
        this.sliderStickyImageViewport.onload = () => {
            setTimeout(() => {
                this.sliderStickyViewportImageAnimation.style.opacity = '1';
            }, 100)
        }
        this.sliderStickyVideoViewport.onloadeddata = () => {
            setTimeout(() => {
                this.sliderStickyViewportImageAnimation.style.opacity = '1';
            }, 100)
            this.sliderStickyVideoViewport.play();
        }
        this.sliderStickyViewportImageAnimation = this.querySelector('.pro-gallery-viewport-image-animation');
        this.stickySliderCount = this.querySelector('.pro-gallery-sticky-slides-count span:first-child');
        this.stickyArrowPrev = this.querySelector('.pro-gallery-sticky-slide-left');
        this.stickyArrowNext = this.querySelector('.pro-gallery-sticky-slide-right');
        console.log(this.sliderStickyImageViewport)
        this.toggleSliderStickySlides.length && this.toggleSliderStickySlides.forEach((toggleSliderStickySlide, index) => {
            if(!toggleSliderStickySlide.classList.contains('pro-gallery-sticky-slider-close')){
                toggleSliderStickySlide.addEventListener('click', () => {
                    this.stickySliderCurrentSlide = index;
                    this.updateSliderStickyMedia(index, toggleSliderStickySlide);
                })
            }
        })
        this.stickyArrowPrev.addEventListener('click', () => {
            this.stickySliderCurrentSlide = this.stickySliderCurrentSlide - 1;
            this.updateSliderStickyMedia();
        })
        this.stickyArrowNext.addEventListener('click', () => {
            this.stickySliderCurrentSlide = this.stickySliderCurrentSlide + 1;
            this.updateSliderStickyMedia();
        })

        this.sliderStickyViewportImageAnimation.addEventListener('touchstart', (event) => {
            this.sliderStartTouchX = event.touches[0].clientX;
            //console.log(this.startTouchX);
        });

        this.sliderStickyViewportImageAnimation.addEventListener('touchend', (event) => {
            this.sliderEndTouchX = event.changedTouches[0].clientX;
            //console.log(this.endTouchX);
            this.sliderDelta = this.sliderStartTouchX  - this.sliderEndTouchX;

            //console.log(Math.abs(this.delta), this.delta);

            if (Math.abs(this.sliderDelta) > 50) { // 50 can be considered a threshold. Adjust as required
                if (this.sliderDelta > 0 && this.stickySliderCurrentSlide < this.length - 1) {
                    this.stickySliderCurrentSlide = this.stickySliderCurrentSlide + 1;
                } else if (this.sliderDelta < 0 && this.stickySliderCurrentSlide > 0) {
                    this.stickySliderCurrentSlide = this.stickySliderCurrentSlide - 1;
                }
                //console.log(this.currentSlideElement);
                this.updateSliderStickyMedia();
            }
        });
    }
    updateSliderStickyMedia(index, toggleSliderStickySlide){
        if(!index){
            index = this.stickySliderCurrentSlide;
        }
        if(!toggleSliderStickySlide){
            toggleSliderStickySlide = this.toggleSliderStickySlides[this.stickySliderCurrentSlide];
        }
        this.checkSliderButtons(index);
        this.stickySliderCount.textContent = index + 1;
        this.sliderStickyViewportImageAnimation.style.opacity = '0';
        setTimeout(() => {
            this.sliderStickyViewportImageAnimation.style.opacity = '1';
        }, 500)
        if(toggleSliderStickySlide.dataset.videoSrc){
            this.sliderStickyImageViewport.style.display = 'none';
            this.sliderStickyVideoViewport.src = toggleSliderStickySlide.dataset.videoSrc;
            this.sliderStickyVideoViewport.style.display = '';
        }else{
            this.sliderStickyVideoViewport.style.display = 'none';
            this.sliderStickyImageViewport.src = toggleSliderStickySlide.dataset.src;
            this.sliderStickyImageViewport.style.display = '';
        }
        this.stickySliderFooterText.textContent = toggleSliderStickySlide.dataset.alt;
    }
    checkSliderButtons(index){
        if(index > 0){
            this.stickyArrowPrev.classList.remove('pro-gallery-sticky-slide-hidden');
        }else{
            this.stickyArrowPrev.classList.add('pro-gallery-sticky-slide-hidden');
        }
        if(index === (this.length - 1)){
            this.stickyArrowNext.classList.add('pro-gallery-sticky-slide-hidden');
        }else{
            this.stickyArrowNext.classList.remove('pro-gallery-sticky-slide-hidden');
        }
    }
    /* Update mobile slider */
    initMobSlider(){
        this.s = 0;
        this.slideWidth = this.querySelector('.pro-gallery-swiper .pro-gallery-swiper-wrap .pro-gallery-swiper-slide').offsetWidth;
        this.currentSlideElement = this.querySelector('.pro-gallery-swiper .pro-gallery-slides-count span:first-child');
        this.startTouchX = 0;
        this.endTouchX = 0;
        this.proGalleryWrapper = this.querySelector(".pro-gallery-swiper-wrap");

        this.proGalleryWrapper.addEventListener('touchstart', (event) => {
            this.startTouchX = event.touches[0].clientX;
            //console.log(this.startTouchX);
        });

        this.proGalleryWrapper.addEventListener('touchend', (event) => {
            this.endTouchX = event.changedTouches[0].clientX;
            //console.log(this.endTouchX);
            this.delta = this.startTouchX - this.endTouchX;

            //console.log(Math.abs(this.delta), this.delta);

            if (Math.abs(this.delta) > 50) { // 50 can be considered a threshold. Adjust as required
                if (this.delta > 0 && this.s < this.length - 1) {
                    this.s++;
                } else if (this.delta < 0 && this.s > 0) {
                    this.s--;
                }
                //console.log(this.currentSlideElement);
                this.currentSlideElement.textContent = this.s + 1;
                this.proGalleryWrapper.style.transform = "translateX(-" + (this.slideWidth * this.s) + "px)";
            }
        });
    }
})